// client/nodes/grid/grid-cell/node-view.ts
import "prosemirror-model";
import { Plugin, PluginKey } from "prosemirror-state";
import { GRID_CELL_KEY } from "../../../../schema/nodes/grid.js";
var GridCellNodeView = class {
  constructor(node, view, getPos) {
    this.node = node;
    this.view = view;
    const cell = document.createElement(`node-grid-cell`);
    cell.setAttribute("class", node.attrs.class);
    cell.view = view;
    cell.getPos = getPos;
    this.dom = cell;
    this.contentDOM = cell;
  }
  update(node) {
    if (node.attrs.data !== this.node.attrs.data)
      return false;
    this.node = node;
    this.dom.setAttribute("class", node.attrs.class);
    return true;
  }
  destroy() {
    this.dom = null;
  }
};
var gridCellNodeView = (node, view, getPos) => {
  return new GridCellNodeView(node, view, getPos);
};
var gridCellViewPlugin = new Plugin({
  key: new PluginKey("grid-cell-nodeview-plugin"),
  props: {
    nodeViews: {
      [GRID_CELL_KEY]: gridCellNodeView
    }
  }
});
export {
  gridCellViewPlugin
};
